/**
 * @author Francesco Napoletano <fnapoletano@ebay.com>
 */
export default class ClickToMap {
    /**
     * @param element
     */
    constructor(element) {
        this.$element = $(element);
        this.setupScript();
        this.$element.off('click').on('click', () => {
            this.showMap();
        });
    }

    setupScript() {
        if($('#gmaps-script').length == 0) {
            var tag = document.createElement('script');
            tag.id = 'gmaps-script';
            tag.src = 'https://maps.googleapis.com/maps/api/js?client=gme-marktplaats&channel=it-automobile-vip';
            tag.async = '';
            tag.defer = '';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    }

    showMap() {
        const mapElement = $(this.$element.data('click-to-map'));
        const map = new google.maps.Map(mapElement.get(0), {
            zoom: 15
        });

        const geocoder = new google.maps.Geocoder();
        this.showAddress(this.$element.data('address'), geocoder, map);
        mapElement.show();
    }

    showAddress(address, geocoder, map) {
        geocoder.geocode({'address': address}, function(results, status) {
            if (status === 'OK') {
                map.setCenter(results[0].geometry.location);
                const marker = new google.maps.Marker({
                    map: map,
                    scaledSize: new google.maps.Size(150, 150), // scaled size
                    icon: '/img/dealer-location-icon.svg',
                    position: results[0].geometry.location
                });
            }
        });
    }
}
